exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header {\n  border-bottom: 5px solid #F7A500;\n  height: 55px; }\n\n.action-ul {\n  float: right;\n  clear: both;\n  right: 10px;\n  transform: translate(0, 50%);\n  font-size: 13px; }\n\n.action-li {\n  cursor: pointer; }\n\n.action-li:not(:first-child) {\n  margin-left: 20px; }\n\n.content {\n  padding: 10px; }\n\n.caption {\n  border-left: 1px solid #6d6d6d;\n  padding: 0 0 0 5px;\n  margin: 0 0 0 10px;\n  line-height: 14px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/header/header.component.scss
// module id = ../../../../../src/app/core/components/header/header.component.scss
// module chunks = main